import lazyLoad from 'core/util/lazyLoad';

export const twoFactorImport = () => import('./VerifyTwoFactor');

export const VerifyTwoFactor = lazyLoad(twoFactorImport);
